var map = {
	"./JP_map.png": 174,
	"./Japanese-alphabet.jpg": 180,
	"./QRcode_images/Alipay.jpg": 181,
	"./QRcode_images/Wechat.jpg": 182,
	"./QRcode_images/btc.jpg": 183,
	"./QRcode_images/eth.jpg": 184,
	"./bhu.jpg": 568,
	"./bing.jpg": 569,
	"./extended_hiragana_list.png": 570,
	"./extended_katakana_list.png": 571,
	"./favicon.png": 243,
	"./handWriting.png": 572,
	"./hira_mnemonics.png": 178,
	"./hiragana-chart.jpg": 573,
	"./hiragana.png": 574,
	"./hiragana2.png": 575,
	"./hiraganakatakana.png": 576,
	"./hiraganakatakana2.png": 179,
	"./hjIcon.png": 171,
	"./jp.png": 172,
	"./kanas.jpg": 577,
	"./katakana.jpg": 578,
	"./learn_jp.png": 579,
	"./learn_jp1.png": 580,
	"./learn_jp2.png": 581,
	"./logo.png": 582,
	"./memrise.png": 173,
	"./profile.png": 242,
	"./threeWay1.png": 175,
	"./threeWay2.png": 176,
	"./threeWay3.png": 177,
	"./五十音速成课.original.png": 583,
	"./五十音速成课.png": 584,
	"./动物平假名之歌.png": 585,
	"./小奶音.png": 586,
	"./日语五十音记不住？唱就完事儿啦.png": 587,
	"./日语朗读？？傲娇台词版五十音图.png": 588,
	"./花泽香菜教你日语五十音.png": 589,
	"./花泽香菜（加长版）.png": 590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 567;